module.exports = __webpack_public_path__ + "static/ohr486-e9477c0c051c0c6ee6c51c1381e2e439.png";